import React from 'react'
import PropTypes from 'prop-types'
import Shimmer from 'Components/shimmer'

const MaleDailyArticleCardThreeShimmer = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div
        className={`article-style-three-shimmer article-style-three-shimmer--${device}`}
      >
        <div className="article-style-three-shimmer__image">
          <Shimmer
            width={isMobile ? '156px' : '274px'}
            height={isMobile ? '88px' : '154px'}
          />
        </div>
        <div className="article-style-three-shimmer__text">
          <Shimmer width="88px" height="12px" />
          <div className="article-style-three-shimmer__title">
            <Shimmer width="100%" height="12px" />
            <Shimmer width="100%" height="12px" />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-style-three-shimmer {
            display: grid;
            grid-template-columns: 274px 1fr;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-three-shimmer--mobile {
            grid-template-columns: 156px 1fr;
          }

          .article-style-three-shimmer__image {
            width: auto;
            aspect-ratio: 16/9;
          }

          .article-style-three-shimmer__text {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .article-style-three-shimmer__image--mobile {
            width: 156px;
            height: auto;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardThreeShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardThreeShimmer
